module.exports = __webpack_public_path__ + "static/background-4c5124e334c7d52cc5be8aa8cd9c5440.svg";